module.exports = __webpack_public_path__ + "img/gzh.f1356506.jpg";